/// <amd-module name="Feed/Connect/Redux/ConnectToFeed/ConnectToFeedSelectors" />
import { getVssPageData } from "VSS/Redux/Modules/VSSPageData";

import { ITool } from "../../Tool";
import { IConnectToFeedAwareState } from "./ConnectToFeedContracts";

export { getSelectedUxFeedView } from "Feed/Core/Redux/FeedHub";
export function getTools(state: IConnectToFeedAwareState): ITool[] {
    return state.connectToFeed.tools;
}

export function getSelectedTool(state: IConnectToFeedAwareState): ITool | undefined {
    return state.connectToFeed.tool;
}

export function getOrganizationName(state: IConnectToFeedAwareState) {
    const vssPageData = getVssPageData(state);

    if (vssPageData) {
        return vssPageData.hostName;
    }
}

export function getIsHosted(state: IConnectToFeedAwareState) {
    const vssPageData = getVssPageData(state);
    if (vssPageData) {
        return vssPageData.isHosted;
    }
}
